export default {
    "welcome": {
        "title": "Witamy w ProcrastiQ",
        "subtitle": "Tw?j towarzysz produktywno?ci",
        "modal": {
            "title": "Witamy w ProcrastiQ",
            "headline": "M?dre prze?omy dla twojego m?zgu",
            "subheading": "Przek?ski dla m?zgu, fakty i uwa?ne chwile, kt?re zamieniaj? wolne chwile w co? warto?ciowego. ",
            "text": "Procrastiq w?a?nie tu prokrastynacja staje si? czym? znacz?cym. Zamiast nieustannie przegl?da? media spo?eczno?ciowe, odkryjesz szybkie przek?ski dla m?zgu, kt?re maj? zabawi?, pobudzi? umys?, a mo?e nawet nauczy? ci? czego? nowego. \n\nNie chodzi tu o produktywno?? za wszelk? cen?. Ka?dy potrzebuje chwili, by si? zatrzyma?, na?adowa? baterie i oderwa? od pracy. Procrastiq pomaga zamieni? te ma?e przerwy w co? pozytywnego ? pe?nego ciekawo?ci, rado?ci i codziennego treningu m?zgu. Ma?e wyzwania. Du?y post?p. ",
            "cta": "Chod?my"
        }
    },
    "login": {
        "title": "Loguj si?",
        "email": "E-mail",
        "password": "Has?o",
        "submit": "Loguj si?",
        "cancel": "Anuluj",
        "success": "Logowanie zako?czy?o si?",
        "lead": "Witamy ponownie ? podnie? swoj? seri? i wspinaj si? po wy?szych ligach. "
    },
    "logout": "Wylogowanie",
    "logo": {
        "title": "ProcrastiQ",
        "slogan": "M?dre prze?omy dla twojego m?zgu"
    },
    "register": {
        "title": "Rejestr",
        "name": "Nazwa",
        "email": "E-mail",
        "password": "Has?o",
        "submit": "Utw?rz konto",
        "cancel": "Anuluj",
        "success": "Rejestracja zako?czona sukcesem",
        "country": "Kraj",
        "lead": "Za??? konto, aby zdobywa? XP, odblokowywa? rangi i do??cza? do cotygodniowych lig. "
    },
    "social": {
        "divider": "Albo kontynuuj",
        "signInWith": "Zaloguj si? przez {{provider}}",
        "continueWith": "Kontynuuj {{provider}}",
        "failed": "Rejestracja spo?eczno?ciowa zawiod?a",
        "popup_blocked": "Popup by? zablokowany. Prosz? zezwoli? na wyskakuj?ce okienka i spr?buj ponownie. ",
        "cancelled": "Rejestracja zosta?a odwo?ana. "
    },
    "common": {
        "cancel": "Anuluj",
        "saving": "Zapisuj?... ",
        "unknown_error": "Nieznany b??d",
        "select_country": "Wybrany kraj",
        "select_option": "Wybierz opcj?",
        "country": "Kraj"
    },
    "language": {
        "page_language": "J?zyk strony",
        "switch_to": "Przejd? na {{language}}"
    },
    "cookies": {
        "title": "Cookies",
        "message": "U?ywamy plik?w cookie do analityki (Google Analytics), aby ulepsza? Procrastiq.",
        "privacy_link": "Polityka prywatno?ci",
        "accept": "Akceptuj?",
        "reject": "Odrzu?"
    },
    "footer": {
        "columns": {
            "about": {
                "title": "O nas",
                "mission": "Misja",
                "progression": "XP, poziomy i ligi",
                "creator_progression": "XP i rangi tw?rcy",
                "contact": "Skontaktuj si? z nami"
            },
            "leaderboards": {
                "title": "Tabele wynik?w",
                "players": "Cz?onkowie",
                "creators": "Wsp??pracownicy"
            },
            "legal": {
                "title": "Prywatno?? i warunki",
                "community": "Wytyczne spo?eczno?ci",
                "terms": "Warunki korzystania z us?ug",
                "privacy": "Polityka prywatno?ci"
            },
            "social": {
                "title": "Spo?ecze?stwo",
                "facebook": "Facebook",
                "instagram": "Instagram"
            }
        }
    },
    "pages": {
        "mission": {
            "title": "Misja",
            "content": "ProcrastiQ zamienia kr?tkie przerwy w znacz?ce chwile ? przek?ski dla m?zgu, zagadki i uwa?ne pauzy, kt?re bawi? i pobudzaj? umys?. \n\nWierzymy, ?e prokrastynacja nie musi by? marnowanym czasem. Ka?dy zas?uguje na chwil? na na?adowanie baterii, a my pomagamy, by te chwile by?y pozytywne, ciekawe i przyjemne. "
        },
        "contact": {
            "title": "Skontaktuj si? z nami",
            "content": "Masz pytanie, pomys? na ulepszenie albo natrafi?e? na co?, co nie dzia?a tak, jak powinno? Napisz do nas ? ka?da opinia pomaga nam dalej ulepsza? Procrastiq.\n\nMo?esz napisa? na:\n\nhello@procrastiq.com\n\nCh?tnie przeczytamy te? Twoje propozycje nowych tre?ci, funkcji lub temat?w, kt?re chcia?by? zobaczy? na Procrastiq."
        },
        "community": {
            "title": "Wytyczne spo?eczno?ci",
            "content": "ProcrastiQ to przyjazna przestrze? dla ciekawskich umys??w. B?d? szanuj?cy, ?yczliwy i konstruktywny w swoich kontaktach. \n\nNie publikuj tre?ci szkodliwych, obra?liwych ani spamowych. Zg?aszaj wszystko, co nie powinno si? tam zaliczy?. Razem utrzymujemy to miejsce jako pozytywne miejsce do nauki i robimy rozs?dne przerwy. "
        },
        "terms": {
            "title": "Warunki korzystania z us?ugi",
            "content": "**Ostatnia aktualizacja: 7 wrze?nia 2026**\n\nKorzystaj?c z us?ugi Procrastiq, zgadzasz si? na niniejsze warunki. Je?li si? z nimi nie zgadzasz, nie korzystaj z us?ugi.\n\n## 1. O Procrastiq\n\nProcrastiq to platforma online skupiona na nauce, quizach, ?amig??wkach i innych tre?ciach interaktywnych.\n\nTre?ci us?ugi s?u?? przede wszystkim edukacji i rozrywce. Nie stanowi? fachowej, prawnej, medycznej, finansowej ani innej specjalistycznej porady.\n\n## 2. Konto u?ytkownika\n\nNiekt?re funkcje Procrastiq mog? wymaga? utworzenia konta u?ytkownika.\n\nOdpowiadasz za prawid?owo?? danych w swoim koncie oraz za zabezpieczenie danych logowania.\n\nKonto nie mo?e by? u?ywane do naruszania praw innych os?b, obowi?zuj?cego prawa ani niniejszych warunk?w.\n\n## 3. Zasady korzystania\n\nPodczas korzystania z Procrastiq niedozwolone jest w szczeg?lno?ci:\n\n* publikowanie tre?ci niezgodnych z prawem, oszuka?czych, nienawistnych lub w inny spos?b szkodliwych,\n* naruszanie praw autorskich lub innych praw os?b trzecich,\n* n?kanie innych u?ytkownik?w,\n* pr?by zak??cania bezpiecze?stwa lub dzia?ania us?ugi,\n* automatyczne pozyskiwanie tre?ci lub danych w spos?b, kt?rego nie zezwalamy,\n* nadu?ywanie ocen, XP, ranking?w lub innych mechanizm?w gry.\n\n## 4. Tre?ci u?ytkownik?w\n\nU?ytkownicy mog? tworzy? lub przesy?a? w?asne tre?ci, na przyk?ad quizy, pytania, komentarze lub inne wpisy.\n\nPrzesy?aj?c tre??, potwierdzasz, ?e masz prawo j? opublikowa?.\n\nZachowujesz prawa do swoich tre?ci. Jednocze?nie udzielasz nam niewy??cznego uprawnienia do przechowywania, wy?wietlania, technicznego dostosowywania i udost?pniania tych tre?ci w ramach Procrastiq w zakresie niezb?dnym do dzia?ania us?ugi.\n\n## 5. Moderacja tre?ci\n\nMo?emy sprawdza? tre?ci u?ytkownik?w i w przypadku naruszenia niniejszych warunk?w lub obowi?zuj?cego prawa odm?wi? ich publikacji, ukry? je lub usun??.\n\nW powa?nych lub powtarzaj?cych si? przypadkach mo?emy ograniczy? lub zamkn?? konto u?ytkownika.\n\nJe?li pozwalaj? na to okoliczno?ci i wymaga tego prawo, poinformujemy u?ytkownika o przyczynie takiej decyzji.\n\n## 6. Tre?ci Procrastiq\n\nTre?ci publikowane bezpo?rednio przez Procrastiq mog? zawiera? b??dy lub nie?cis?o?ci. Cho? staramy si? je weryfikowa? i stale ulepsza?, nie mo?emy gwarantowa? ich kompletno?ci ani wolno?ci od b??d?w.\n\nQuizy i inne tre?ci edukacyjne maj? przede wszystkim charakter informacyjny i rozrywkowy.\n\n## 7. Dost?pno?? us?ugi\n\nStaramy si? utrzymywa? Procrastiq w stanie dost?pnym i sprawnym, nie mo?emy jednak gwarantowa? nieprzerwanego ani bezb??dnego dzia?ania.\n\nMo?emy z czasem zmienia?, rozszerza? lub ko?czy? cz??ci us?ugi.\n\n## 8. Odpowiedzialno??\n\nW zakresie dozwolonym przez obowi?zuj?ce prawo nie ponosimy odpowiedzialno?ci za szkody wynikaj?ce z niew?a?ciwego korzystania z us?ugi lub polegania na tre?ciach o charakterze wy??cznie informacyjnym lub edukacyjnym.\n\nNie narusza to praw u?ytkownik?w, kt?rych nie mo?na ograniczy? na podstawie obowi?zuj?cego prawa.\n\n## 9. Ochrona danych osobowych\n\nInformacje o przetwarzaniu danych osobowych znajdziesz w naszej [Polityce prywatno?ci](/legal/privacy).\n\n## 10. Zmiany niniejszych warunk?w\n\nMo?emy od czasu do czasu aktualizowa? te warunki, na przyk?ad ze wzgl?du na zmiany us?ugi, przepis?w prawa lub sposobu dzia?ania Procrastiq.\n\nData ostatniej aktualizacji b?dzie zawsze podana u g?ry tej strony. O istotnych zmianach mo?emy te? poinformowa? u?ytkownik?w bezpo?rednio w us?udze lub e-mailem.\n\n## 11. Kontakt\n\nJe?li masz pytania dotycz?ce niniejszych warunk?w, napisz do nas na:\n\n[hello@procrastiq.com](mailto:hello@procrastiq.com)"
        },
        "privacy": {
            "title": "Polityka prywatno?ci",
            "content": "**Ostatnia aktualizacja: 7 wrze?nia 2026**\n\nTraktujemy Twoj? prywatno?? powa?nie. Poni?ej wyja?niamy, jakie dane osobowe przetwarzamy podczas korzystania z Procrastiq, dlaczego ich potrzebujemy i jakie masz prawa.\n\n## 1. Kto przetwarza dane\n\nAdministratorem danych osobowych jest:\n\n**Michal Orl?k**\nosoba fizyczna\n\nKontakt w sprawach ochrony danych osobowych:\n\n**[hello@procrastiq.com](mailto:hello@procrastiq.com)**\n\n## 2. Jakie dane przetwarzamy\n\nW zale?no?ci od tego, jak korzystasz z Procrastiq, mo?emy przetwarza? w szczeg?lno?ci:\n\n* dane Twojego konta, na przyk?ad imi? i nazwisko, nazw? u?ytkownika oraz adres e-mail,\n* dane uzyskane przy logowaniu przez us?ug? zewn?trzn?, na przyk?ad Google,\n* informacje o korzystaniu z us?ugi, na przyk?ad wy?wietlane tre?ci, wyniki quiz?w, zdobyte XP, serie, reakcje, zak?adki oraz aktywno?? w feedzie,\n* tre?ci, kt?re sam tworzysz lub przesy?asz,\n* dane techniczne, na przyk?ad adres IP, typ urz?dzenia, przegl?dark? oraz informacje potrzebne do bezpiecze?stwa i prawid?owego dzia?ania us?ugi.\n\n## 3. Dlaczego u?ywamy danych\n\nDanych osobowych u?ywamy g??wnie po to, aby:\n\n* utworzy? i zarz?dza? Twoim kontem,\n* ?wiadczy? funkcje Procrastiq,\n* zapisywa? Tw?j post?p, wyniki, XP i inn? aktywno??,\n* dopasowywa? tre?ci i rekomendacje,\n* chroni? us?ug? przed nadu?yciami,\n* rozwi?zywa? b??dy i problemy techniczne,\n* komunikowa? si? z Tob?,\n* analizowa? i ulepsza? dzia?anie us?ugi.\n\n## 4. Podstawa prawna przetwarzania\n\nDane przetwarzamy w zale?no?ci od celu g??wnie:\n\n* poniewa? s? niezb?dne do ?wiadczenia us?ugi,\n* na podstawie naszego prawnie uzasadnionego interesu w zabezpieczeniu i ulepszaniu Procrastiq,\n* na podstawie Twojej zgody, gdy zgoda jest wymagana,\n* lub w celu wype?nienia obowi?zk?w prawnych.\n\nJe?li przetwarzanie opiera si? na zgodzie, mo?esz j? w ka?dej chwili wycofa?.\n\n## 5. Komu dane mog? by? przekazywane\n\nNie sprzedajemy Twoich danych osobowych.\n\nDo prowadzenia us?ugi mo?emy jednak korzysta? z zewn?trznych dostawc?w, na przyk?ad w zakresie:\n\n* hostingu i infrastruktury,\n* logowania u?ytkownik?w,\n* wysy?ki e-maili i powiadomie?,\n* analityki i diagnostyki b??d?w.\n\nCi dostawcy mog? przetwarza? dane wy??cznie w zakresie potrzebnym do ?wiadczenia swoich us?ug.\n\n## 6. Jak d?ugo przechowujemy dane\n\nDane powi?zane z Twoim kontem przechowujemy zazwyczaj przez czas istnienia konta, a nast?pnie przez okres niezb?dny do spe?nienia obowi?zk?w prawnych lub ochrony naszych prawnie uzasadnionych interes?w.\n\nDane techniczne i analityczne przechowujemy tylko przez czas potrzebny do ich celu.\n\n## 7. Twoje prawa\n\nW zwi?zku z przetwarzaniem danych osobowych masz w zale?no?ci od okoliczno?ci prawo do:\n\n* uzyskania informacji o tym, jakie dane o Tobie przetwarzamy,\n* ??dania sprostowania niedok?adnych danych,\n* ??dania usuni?cia danych,\n* ??dania ograniczenia ich przetwarzania,\n* wniesienia sprzeciwu wobec niekt?rych sposob?w przetwarzania,\n* otrzymania swoich danych w formacie przeno?nym,\n* wycofania udzielonej zgody.\n\nWniosek mo?esz wys?a? na:\n\n**[hello@procrastiq.com](mailto:hello@procrastiq.com)**\n\nNa wnioski odpowiadamy zgodnie z obowi?zuj?cymi przepisami prawa.\n\n## 8. Usuni?cie konta\n\nJe?li us?uga umo?liwia usuni?cie konta, mo?esz poprosi? o jego usuni?cie bezpo?rednio w ustawieniach konta lub skontaktowa? si? z nami pod adresem **[hello@procrastiq.com](mailto:hello@procrastiq.com)**.\n\nPo usuni?ciu konta usuwamy lub anonimizujemy dane osobowe, kt?rych nie musimy ju? przechowywa? z przyczyn prawnych lub bezpiecze?stwa.\n\n## 9. Pliki cookie i podobne technologie\n\nProcrastiq mo?e u?ywa? plik?w cookie i podobnych technologii potrzebnych do logowania, bezpiecze?stwa, zapisywania ustawie? oraz ewentualnie analityki.\n\nBardziej szczeg??owe informacje o cookie mog? znajdowa? si? w osobnej polityce cookie.\n\n## 10. Bezpiecze?stwo\n\nStosujemy odpowiednie ?rodki techniczne i organizacyjne w celu ochrony danych osobowych przed nieuprawnionym dost?pem, utrat? lub nadu?yciem.\n\n?aden system nie mo?e jednak by? uznany za absolutnie bezpieczny.\n\n## 11. Skarga\n\nJe?li uwa?asz, ?e przetwarzamy Twoje dane osobowe z naruszeniem obowi?zuj?cych przepis?w, mo?esz te? zwr?ci? si? do w?a?ciwego organu nadzorczego.\n\nW Republice Czeskiej jest nim **Urz?d Ochrony Danych Osobowych (??ad pro ochranu osobn?ch ?daj?)**.\n\n## 12. Zmiany tej polityki\n\nMo?emy od czasu do czasu aktualizowa? t? polityk?, na przyk?ad w zwi?zku z nowymi funkcjami lub zmianami przepis?w.\n\nDat? ostatniej aktualizacji zawsze podamy w g?rnej cz??ci tej strony."
        },
        "progression": {
            "title": "XP, poziomy i ligi",
            "content": "ProcrastiQ nagradza ciekawo??. Odpowiadaj na quizy, buduj serie i przechod? od casualowych przek?sek do cotygodniowych zawod?w. \n\n## Punkty do?wiadczenia (XP)\n\nZdobywasz sta?e XP, gdy grasz dobrze ? na przyk?ad poprawne odpowiedzi, bonusy za pierwsz? pr?b?, trudniejsze pytania, powt?rki i codzienne cele. Sta?e XP nigdy si? nie resetuje i zawsze liczy si? do poziomu. \n\nJest te? do?wiadczenie rankingowe, kt?re jest u?ywane tylko w tygodniowych ligach. Do?wiadczenie rankingowe wykorzystuje codziennie malej?ce zwroty: wczesne do?wiadczenie w ci?gu dnia liczy si? w pe?ni, p??niejsze zdobywane mniej. To utrzymuje uczciw? rywalizacj?, je?li kto? gra ca?y dzie?. \n\n## Poziomy\n\nTw?j poziom pochodzi z ca?kowitego sta?ego XP. Ka?dy poziom wymaga troch? wi?cej XP ni? poprzedni (krzywa rosn?ca), wi?c post?py pozostaj? znacz?ce.\n\nTw?j profil pokazuje, ile XP masz na bie??cym poziomie i ile potrzebujesz na nast?pny. \n\n## Rankingi tytu??w\n\nRangi to tytu?y odblokowywane przez poziom. S? odznak? tego, jak daleko zaszed?e? ? oddzielnie od cotygodniowych poziom?w ligowych. \n\n- Poziom 1 ? Ciekawski Umys?\n- Poziom 3 ? Explorer\n- Poziom 5 ? Badacz\n- Poziom 8 ? Rozwi?zywacz problem?w\n- Poziom 12 ? Analityk\n- Poziom 18 ? Logik\n- Poziom 25 ? Strateg\n- Poziom 35 ? Polimat\n- Poziom 50 ? Geniusz\n- Poziom 70 ? Mistrz wiedzy\n- Poziom 100 ? Procrastiq Legenda\n\n## Ligi tygodniowe\n\nLigi to cotygodniowa rywalizacja z innymi zawodnikami w grupach oko?o 20 os?b. \n\nPoziomy od najni?szego do najwy?szego: \n\n- ?elazo\n- Br?z\n- Srebro\n- Z?oto\n- Platyna\n- Diament\n- Mistrz\n- Legendarny\n\nCo tydzie? rywalizujesz o rankingowe XP w swojej grupie. Na koniec tygodnia mniej wi?cej najlepsi gracze awansuj? o jeden poziom, a najs?absi spadaj? o jeden poziom. Wszyscy inni zostaj?. \n\nNie czekasz na poniedzia?kowy reset, by do??czy?. Gdy staniesz si? uprawniony, od razu trafiasz do otwartej grupy ? lub tworzona jest dla ciebie nowa grupa. \n\nAby odblokowa? ligi, zazwyczaj potrzebujesz: \n\n- co najmniej 100 sta?ych XP\n- co najmniej 10 uko?czonych dzia?a?\n- aktywno?? co najmniej 2 r??ne dni\n- Widoczno?? w rankingach dla Twojego profilu\n\nOtw?rz stron? Ranking?w lub panel statystyk w dowolnym momencie, aby zobaczy? sw?j tier, pozycj? i grup?. "
        },
        "creator_progression": {
            "title": "XP i rangi tw?rcy",
            "content": "Tworzenie tre?ci na ProcrastiQ ma w?asny rozw?j ? ca?kowicie oddzielny od XP gracza, poziom?w i tygodniowych lig. \n\nGdy ludzie lubi? twoje quizy i przek?ski m?zgu, zdobywasz Creator XP (CXP). CXP odblokowuje rankingi tw?rc?w i umieszcza ci? na tablicach wynik?w Contributors. \n\n## Dwa niezale?ne systemy\n\n- Post?p zawodnik?w ? XP z gry, poziom?w, rang tytu?owych, tygodniowych lig\n- Rozw?j tw?rc?w ? CXP poprzez dostarczanie wysokiej jako?ci tre?ci, rankingi tw?rc?w, tablice wsp??tw?rc?w\n\nGranie nie podnosi twojego poziomu tw?rcy. Tworzenie nie podnosi poziomu twojego gracza. Mo?esz rozwija? si? na obu ?cie?kach jednocze?nie. \n\n## Jak zdobywasz XP Tw?rcy\n\nCXP jest przyznawane za zatwierdzone wk?ady i zaanga?owanie w te tre?ci ? a nie za liczb? z?o?onych szkic?w.\n\nTypowe nagrody: \n\n- Zatwierdzona zawarto?? ? +20 CXP (raz za przedmiot)\n- Co 10 uko?cze? tre?ci ? +2 CXP\n- Co 10 polubie? pod tre?ci? ? +5 CXP\n- Co 10 zak?adek w Twoich tre?ciach ? +2 CXP\n\nWy?wietlenia i inne statystyki s? ?ledzone na Twoim profilu tw?rcy, ale tylko powy?sze nagrody przyznaj? CXP. Warto?ci mog? by? dostosowywane w czasie. \n\n## Rangi tw?rcy\n\nTw?j ranking tw?rcy pochodzi z ca?kowitego CXP. Progi rosn? mniej wi?cej wyk?adniczo, wi?c wczesny post?p wydaje si? szybki, a wy?sze rangi maj? sens. \n\n- 0 CXP ? Wsp??tw?rca\n- 50 CXP ? Tw?rca\n- 150 CXP ? Autor\n- 400 CXP ? Ekspert\n- 1,000 CXP ? Mentor\n- 2 500 CXP ? Master Creator\n- 6 000 CXP ? Procrastiq Sage\n\nTw?j profil pokazuje Tw?j aktualny ranking, CXP i post?py w kierunku kolejnego rankingu. \n\n## Rankingi wsp??tw?rc?w\n\nTw?rcy s? klasyfikowani wed?ug Creator XP, a nie liczby zg?osze?. \n\n- Tygodniowo ? CXP zdobyte w tym tygodniu\n- Miesi?cznie ? CXP zdobyte w tym miesi?cu\n- Ca?kowite ? ??czny CXP\n\nOtw?rz rankingi i prze??cz si? na Contributors, aby zobaczy?, kto si? wspina. "
        }
    },
    "account": {
        "profile_picture": "Zdj?cie profilowe",
        "save_changes": "Zmiany zapisu",
        "update_success": "Profil zaktualizowany pomy?lnie",
        "update_failed": "Nie uda?o si? zaktualizowa? profilu",
        "country": "Kraj",
        "avatar": {
            "upload_label": "Upload Avatar",
            "upload_success": "Awatar przes?any pomy?lnie",
            "upload_failed": "Nie uda?o si? przes?a? awatara",
            "delete_confirm": "Jeste? pewien, ?e chcesz usun?? swojego awatara? ",
            "delete_success": "Awatar usuni?ty pomy?lnie",
            "delete_failed": "Nie uda?o si? usun?? awatara"
        },
        "password": {
            "set_optional": "Ustaw has?o (opcjonalnie)",
            "change_optional": "Zmie? has?o (opcjonalnie)",
            "oauth_info": "Zalogowa?e? si? {{method}}. Mo?esz opcjonalnie ustawi? has?o, aby w??czy? zalogowanie do e-maila/has?a. ",
            "current": "Aktualne has?o",
            "current_placeholder": "Wprowad? aktualne has?o",
            "current_required": "Do zmiany has?a wymagane jest obecne has?o",
            "new": "Nowe has?o",
            "set_placeholder": "Ustaw has?o",
            "leave_blank_placeholder": "Zostawi? puste, aby pozosta? aktualnym",
            "confirm": "Potwierd? nowe has?o",
            "confirm_placeholder": "Potwierd? nowe has?o",
            "mismatch": "Nowe has?a si? nie zgadzaj?"
        }
    },
    "play": {
        "label": "Play",
        "games": {
            "focus": "Fokus",
            "reflex": "Refleks",
            "memory": "Pami??",
            "sequence": "Sekwencja",
            "switch": "Prze??cz",
            "rotate": "Obr?t",
            "reason": "Rozumowanie"
        },
        "actions": {
            "check": "Check",
            "continue": "Continue",
            "start": "Start"
        },
        "countdown": {
            "go": "Start!"
        },
        "intro": {
            "what": "Co to jest",
            "why": "Dlaczego to proponujemy",
            "how": "Co robi?"
        },
        "focus": {
            "start_hint": "Remember the highlighted targets, track them as they move, then tap them again.",
            "hint_preview": "Remember these {{n}} targets.",
            "hint_track": "Keep tracking them?",
            "hint_select": "Tap the targets you tracked.",
            "arena": "Tracking area",
            "object": "Object {{n}}"
        },
        "reflex": {
            "progress": "{{current}} / {{total}}",
            "tap": "Response pad",
            "go": "TAP",
            "nogo": "WAIT",
            "rules": {
                "skip_red": {
                    "hint": "Dotknij zielonego lub niebieskiego. Nie dotykaj czerwonego.",
                    "countdown_hint": "Gotowy ? dotknij zielonego lub niebieskiego, pomi? czerwony."
                },
                "skip_green": {
                    "hint": "Dotknij czerwonego lub niebieskiego. Nie dotykaj zielonego.",
                    "countdown_hint": "Gotowy ? dotknij czerwonego lub niebieskiego, pomi? zielony."
                },
                "skip_blue": {
                    "hint": "Dotknij zielonego lub czerwonego. Nie dotykaj niebieskiego.",
                    "countdown_hint": "Gotowy ? dotknij zielonego lub czerwonego, pomi? niebieski."
                }
            }
        },
        "memory": {
            "countdown_hint": "Gotowy ? zapami?taj wz?r, a potem zmiany.",
            "countdown_hint_stream": "Gotowy ? zapami?taj tylko ostatnie symbole.",
            "hint_preview": "Remember which squares are on.",
            "hint_on": "Square {{n}} ON",
            "hint_off": "Square {{n}} OFF",
            "hint_final": "Recreate the final pattern.",
            "hint_stream": "Watch the symbols?",
            "hint_last_n": "Tap the last {{n}} symbols in order.",
            "intro": {
                "tagline": "Przechowaj informacj? przez chwil?, a potem jej u?yj.",
                "what": "Kr?tkie ?wiczenie pami?ci roboczej: zapami?taj wz?r lub niedawne symbole, a potem je odtw?rz.",
                "why": "Pami?? robocza wspiera skupienie i nauk? ? kr?tki trening utrzymuje umiej?tno?? bez d?ugich drill?w.",
                "how": "Obserwuj uwa?nie, poczekaj na zmiany lub strumie?, potem stuknij odpowied?. Dok?adno?? liczy si? bardziej ni? szybko??."
            }
        },
        "sequence": {
            "countdown_hint": "Get ready ? the sequence is about to start.",
            "hint_watch_forward": "Watch the sequence.",
            "hint_watch_reverse": "Watch ? you will repeat it backwards.",
            "hint_watch_filter": "Watch ? remember only the blue items.",
            "hint_watch_interference": "Watch carefully.",
            "hint_distract": "?",
            "hint_input_forward": "Repeat the sequence.",
            "hint_input_reverse": "Enter it in reverse.",
            "hint_input_filter": "Enter only the blue items.",
            "hint_input_interference": "Now repeat the sequence.",
            "progress": "{{current}} / {{total}}",
            "pad": "Pad {{n}}",
            "pads": "Sequence pads"
        },
        "switch": {
            "start_hint": "Follow the current rule (color or shape) and pick the matching answer. The rule can change.",
            "rule": "Rule: {{rule}}",
            "progress": "{{current}} / {{total}}",
            "rules": {
                "color": "COLOR",
                "shape": "SHAPE"
            },
            "options": {
                "red": "Red",
                "blue": "Blue",
                "green": "Green",
                "circle": "Circle",
                "square": "Square",
                "triangle": "Triangle"
            }
        },
        "rotate": {
            "start_hint": "Is the right shape the same as the left one, only rotated? Yes or no.",
            "hint": "Same shape, only rotated?",
            "progress": "{{current}} / {{total}}",
            "reference": "Reference shape",
            "comparison": "Comparison shape",
            "yes": "Yes",
            "no": "No"
        },
        "reason": {
            "progress": "{{current}} / {{total}}",
            "modes": {
                "operators": "Operators",
                "running_total": "Running total",
                "number_relations": "Relations",
                "balance": "Balance"
            },
            "start_hints": {
                "operators": "Choose the operators that make the equation correct.",
                "running_total": "Add the numbers as they appear. Then pick the total sum.",
                "number_relations": "Find the number that matches the given rule for the target.",
                "balance": "Use the equations to find each shape’s value, then solve the missing result."
            },
            "operators": {
                "prompt": "Choose the correct equation."
            },
            "running_total": {
                "progress": "Sequence {{current}} / {{total}}",
                "watch": "Add the numbers as they appear.",
                "ask": "What is the sum of all shown numbers?"
            },
            "relations": {
                "square": "Which number is the square of {{n}}?",
                "square_root": "Which number is the square root of {{n}}?",
                "double": "Which number is double {{n}}?",
                "half": "Which number is half of {{n}}?",
                "triple": "Which number is triple {{n}}?",
                "one_third": "Which number is one third of {{n}}?",
                "next_multiple": "Which number is the next multiple of {{step}} after {{n}}?",
                "simple_difference": "Which number is {{step}} less than {{n}}?"
            },
            "balance": {
                "prompt": "What is the missing value?"
            }
        },
        "result": {
            "success": "Nice!",
            "finished": "Done",
            "fail": "? Wrong.",
            "score": "Score {{n}}",
            "accuracy": "{{n}}% accuracy",
            "level": "Level {{n}}",
            "personal_best": "New personal best",
            "level_unlocked": "Level {{n}} unlocked",
            "level_adjusted": "Difficulty adjusted"
        }
    },

    "pause": {
        "label": "Pauza",
        "start": "Zacznij",
        "skip": "Pomin",
        "skip_step": "Pomin ten krok",
        "continue": "Kontynuuj",
        "why_this_works": "Dlaczego to dziala",
        "research": "Zobacz badania",
        "continue_to_duration": "Wybierz czas",
        "intro": {
            "what": "O co chodzi",
            "why": "Dlaczego to proponujemy",
            "how": "Jak to zrobic"
        },
        "protocols": {
            "paced_breathing": {
                "name": "Zwolnij",
                "tagline": "Zwolnij oddech do rownego rytmu.",
                "what": "Piec sekund wdechu i piec wydechu, prowadzone przez kolo, ktore rosnie i maleje.",
                "why": "Wolny, rowny oddech to jeden z najlepiej zbadanych sposobow na wyciszenie po skupionej pracy.",
                "how": "Wdychaj nosem, gdy kolo rosnie, i wydychaj, gdy maleje. Zostan w komforcie.",
                "safety": "Nigdy nie wymuszaj oddechu. Jesli zakreci ci sie w glowie, przerwij i oddychaj normalnie."
            },
            "cyclic_sigh": {
                "name": "G??boki reset",
                "tagline": "Podwojny wdech i dlugi wydech.",
                "what": "Dwa wdechy nosem, a po nich wolniejszy wydech ustami, powtarzane.",
                "why": "To dlugi wydech ludzie najczesciej opisuja jako uspokajajacy; byl badany jako krotka praktyka oddechowa.",
                "how": "Zrob wdech, dodaj krotki drugi wdech i powoli wypusc powietrze ustami.",
                "safety": "Oddychaj zawsze delikatnie i pomin to cwiczenie, jesli czujesz zawroty glowy."
            },
            "progressive_release": {
                "name": "Rozlu?nij",
                "tagline": "Napnij grupe miesni, a potem ja pusc.",
                "what": "Przechodzisz przez kilka grup miesni, na chwile napinajac kazda i nastepnie ja rozluzniajac.",
                "why": "Kontrast miedzy napieciem a rozluznieniem ulatwia zauwazenie, gdzie trzymales napiecie.",
                "how": "Delikatnie napnij wskazana okolice, calkiem ja pusc i zauwaz roznice.",
                "safety": "Napinaj tylko lekko i omijaj kazde bolace lub kontuzjowane miejsce."
            },
            "nature_restore": {
                "name": "Odn?w",
                "tagline": "Daj oczom odpoczac na spokojnym widoku natury.",
                "what": "Krotki, cichy klip z natura, na ktory mozesz patrzec zamiast na prace.",
                "why": "Patrzenie na natore to popularny sposob, by dac odpoczac skupionej uwadze.",
                "how": "Po prostu patrz. Pozwol wzrokowi zmieknac i sledz to, co sie porusza.",
                "safety": "Jesli kolejny ekran to nie jest przerwa, ktorej potrzebujesz, pomin to i spojrz przez okno."
            }
        },
        "duration": {
            "prompt": "Ile masz czasu?",
            "short": "Krotka",
            "recommended": "Zalecana",
            "seconds": "{{n}} s",
            "minutes": "{{n}} min"
        },
        "breathing": {
            "inhale": "Wdech",
            "exhale": "Wydech"
        },
        "cyclic": {
            "inhale": "Wdech",
            "topup": "Dobierz krotki wdech",
            "exhale": "Dlugi wydech"
        },
        "release": {
            "tense": "Delikatnie napnij: {{group}}",
            "release": "Pusc napiecie",
            "notice": "Zauwaz roznice",
            "steps": {
                "hands": "D?onie",
                "forearms": "Przedramiona",
                "hands_forearms": "D?onie i przedramiona",
                "shoulders": "Barki",
                "shoulders_back": "Barki i g?rne plecy",
                "face": "Twarz i szcz?ka",
                "face_jaw": "Twarz i szcz?ka",
                "upper_back": "G?rne plecy",
                "back": "Plecy",
                "belly": "Brzuch",
                "legs": "Nogi",
                "feet": "Stopy",
                "legs_feet": "Nogi i stopy",
                "arms": "R?ce"
            }
        },
        "nature": {
            "hint": "Pozwol oczom spoczac na scenie.",
            "unavailable": "Nie ma jeszcze dostepnego klipu z natura.",
            "scenes": {
                "scene_01": "Spokojna scena natury",
                "scene_02": "Spokojna scena natury",
                "scene_03": "Spokojna scena natury",
                "scene_04": "Spokojna scena natury",
                "scene_05": "Spokojna scena natury",
                "scene_06": "Spokojna scena natury",
                "scene_07": "Spokojna scena natury",
                "scene_08": "Spokojna scena natury"
            }
        },
        "complete": {
            "title": "Gotowe"
        },
        "feedback": {
            "prompt": "Czy to pomoglo?",
            "yes": "Tak",
            "a_little": "Troche",
            "no": "Raczej nie"
        }
    },

    "content": {
        "loading": "?adowanie... ",
        "no_content": "Na razie brak tre?ci. ",
        "feed_exhausted_tag": "Ju? odpowiedzia?e? na wszystko w sprawie tego tagu",
        "feed_exhausted_category": "Ju? odpowiedzia?e? na wszystko w tej kategorii",
        "browse_feed": "Przegl?daj kana? tre?ci",
        "back_to_feed": "? Powr?t do karmy",
        "back": "? Back",
        "content_not_found": "Tre?? nieznaleziona",
        "failed_load": "Nie uda?o si? za?adowa? tre?ci",
        "failed_load_more": "Nie uda?o si? za?adowa? wi?cej",
        "list": {
            "showing": "Pokazywanie {{count}} {{total}}",
            "load_more": "Za?aduj wi?cej"
        },
        "answer": {
            "your_answer": "Twoja odpowied?... ",
            "your_result_or_answer": "Tw?j wynik czy odpowied?... ",
            "select_or_type": "Wybierz swoj? odpowied?... ",
            "fill_in_blank": "Wype?nij luk?... ",
            "your_answer_flip": "Twoja odpowied? (lub przewr?t, ?eby sprawdzi?)... ",
            "reveal_answer": "Odpowied? ujawnij",
            "self_check_prompt": "Wiedzia?e? o tym? ",
            "knew_it": "Wiedzia?em",
            "need_practice": "Potrzebuj? wi?cej praktyki",
            "check": "Sprawdzone",
            "completed": "Uko?czone",
            "completing": "Zapisuj?... ",
            "skip": "Pomi?",
            "next": "Nast?pny",
            "checking": "Sprawdzam... ",
            "correct": "? Zgadza si?! ",
            "not_quite": "? Nie do ko?ca. ",
            "correct_answer": "Poprawna odpowied?: {{answer}}"
        },
        "stats": {
            "sign_in_to_react": "Zaloguj si?, aby polubi? lub nie lubi?",
            "bookmark": "Zak?adka",
            "remove_bookmark": "Usu? zak?adk?",
            "save_for_later": "Zachowaj na p??niej",
            "saved": "Uratowany",
            "share": "Udost?pnij",
            "link_copied": "Link skopiowany do schowka",
            "share_failed": "Nie mog?em udost?pni? tego quizu",
            "completions": "Uko?czenia: {{count}}",
            "aria_like": "Na przyk?ad",
            "aria_dislike": "Niech??"
        },
        "admin": {
            "edit": "Edytuj",
            "delete": "Usu?",
            "stats": "Statystyki",
            "stats_title": "Statystyki tre?ci",
            "delete_confirm": "Usun?? ?{{title}}??",
            "deleted": "Tre?? usuni?ta",
            "delete_failed": "Nie uda?o si? usun?? tre?ci",
            "load_failed": "Nie uda?o si? wczyta? tre?ci",
            "id": "ID",
            "slug": "Slug",
            "status": "Status",
            "locale": "J?zyk",
            "likes": "Polubienia",
            "dislikes": "Niepolubienia",
            "completions": "Uko?czenia",
            "open_in_admin": "Otw?rz w panelu admina"
        },
        "difficulty": {
            "label": "Trudno??: {{value}}/{{max}}",
            "value": "{{value}}/{{max}}",
            "aria": "Trudno?? {{value}} nie {{max}}"
        },
        "detail": {
            "sign_in_to_answer": "Zaloguj si?, aby odpowiedzie? na to pytanie. ",
            "duration": "Czas trwania: {{minutes}} min",
            "phase": "Faza {{number}}"
        },
        "list_item": {
            "completions": "{{count}} uko?czenia",
            "completions_label": "Uko?czenia: {{count}}"
        },
        "feed": {
            "success": "Zgadza si?! ??",
            "skip": "Pomi?",
            "next": "Nast?pny",
            "intro_gate": {
                "title": "Zaloguj si?, aby kontynuowa?",
                "body": "Zaloguj si? lub za?? konto, a Procrastiq zacznie dopasowywa? si? do tego, co lubisz.",
                "body_more": "Nie b?dzie zb?dnie powtarza? tych samych pyta?, zapami?ta Twoje wyniki i zaproponuje tre?ci wed?ug Twoich zainteresowa?.",
                "perks": "Dodatkowo zyskasz dost?p do XP, lig, Survivalu, wyzwa? z innymi graczami i innych funkcji.",
                "register": "Utw?rz konto",
                "login": "Zaloguj si?"
            }
        }
    },
    "categories": {
        "title": "Kategorie",
        "filter": "Filtruj wed?ug kategorii",
        "all": "Wszyscy",
        "loading": "Kategorie ?adowania... ",
        "empty": "Brak kategorii",
        "expand": "Rozwijaj podkategorie",
        "collapse": "Podkategorie zapadania"
    },
    "tags": {
        "title": "Tagi",
        "all": "Wszyscy",
        "loading": "?adowanie tag?w... ",
        "empty": "Bez tag?w"
    },
    "bookmarks": {
        "title": "Zapisane zak?adki",
        "empty": "Na razie nie ma zapisanych tre?ci. "
    },
    "contribute": {
        "title": "Przyczyn",
        "subtitle": "Przesy?aj quizy do przegl?du. Po zatwierdzeniu pojawiaj? si? w kanale. ",
        "subtitle_reliable": "Jeste? wiarygodnym wsp??pracownikiem ? Twoje quizy s? natychmiast dost?pne. ",
        "add": "+ Przes?aj quiz",
        "add_first": "Z??? sw?j pierwszy quiz",
        "empty": "Jeszcze nie przes?a?e? ?adnych tre?ci. ",
        "load_failed": "Nie uda?o si? za?adowa? tre?ci",
        "cannot_edit_approved": "Zatwierdzone tre?ci mog? by? zmieniane tylko przez administratora. ",
        "delete_confirm": "Usun?? \"{{title}}\"? ",
        "deleted": "Zawarto?? usuni?ta",
        "delete_failed": "Nie uda?o si? usun?? tre?ci",
        "edit": "Edycja",
        "delete": "Usu?",
        "form": {
            "submit_title": "Z??? quiz",
            "edit_title": "Redaguj sw?j quiz",
            "submit_button": "Prze?lij do recenzji",
            "save_button": "Zmiany w zapisach",
            "hint": "Tw?j quiz zostanie przejrzany przed pojawieniem si? w kanale. Wiarygodni wsp??pracownicy s? publikowani natychmiast. ",
            "success_updated": "Zawarto?? zaktualizowana pomy?lnie",
            "success_published": "Tre?ci opublikowane z powodzeniem",
            "success_submitted": "Tre?? przes?ana do recenzji",
            "success_created": "Tre?ci stworzone z powodzeniem",
            "success_translation": "T?umaczenie stworzone pomy?lnie",
            "failed": "Nie uda?o si? {{action}} tre?ci",
            "action_update": "Aktualizacja",
            "action_create": "stw?rz",
            "choose_translation_language": "Wybierz j?zyk do t?umaczenia. ",
            "admin_add": "Dodaj tre??",
            "admin_edit": "Edytuj tre??",
            "admin_add_translation": "Dodaj t?umaczenie",
            "admin_add_translation_lang": "Dodaj {{lang}} t?umaczenie",
            "admin_create": "Tw?rz tre?ci",
            "admin_update": "Tre?? aktualizacji",
            "admin_create_translation": "Utw?rz t?umaczenie"
        }
    },
    "content_form": {
        "title": "Tytu?",
        "slug": "?limak",
        "language": "J?zyk",
        "difficulty": "Trudno?? (1?5)",
        "country": "Kraj",
        "status": "Status",
        "visibility": "Widoczno??",
        "categories": "Kategorie",
        "tags": "Tagi",
        "translations": "T?umaczenia",
        "translation_new": "(nowe)",
        "translate_hint": "Przet?umacz pytanie, opcje i wyja?nienie. Metadane (trudno??, kategorie, tagi) s? kopiowane z ?r?d?a. ",
        "choose_language": "Wybierz j?zyk",
        "not_set": "Nie ustawione",
        "description": "Opis",
        "description_placeholder": "Pytanie lub opis zadania",
        "options": "Opcje",
        "option_n": "Opcja {{n}}",
        "add_option": "+ Dodaj opcj?",
        "remove": "Usu?",
        "correct_answer": "Poprawna odpowied?",
        "explanation": "Wyja?nienie",
        "explanation_placeholder": "Opcjonalne ? pokazane po b??dnej odpowiedzi"
    },
    "user_stats": {
        "title": "Twoje statystyki",
        "sign_in_prompt": "Zaloguj si?, aby zobaczy? swoje statystyki",
        "guest_title": "Ranga. Poziom. Wspinanie si? po ligach. ",
        "guest_lead": "?led? XP, odblokowuj rangi tytu??w i rywalizuj w cotygodniowych ligach po zalogowaniu. ",
        "guest_perk_level": "Zdobywaj XP na quizach i awansuj przez poziomy. ",
        "guest_perk_rank": "Odblokuj rankingi tytu??w wraz ze wzrostem poziomu. ",
        "guest_perk_league": "Do??cz do cotygodniowych grup i awansuj w kierunku Legendarnego. ",
        "xp": "XP",
        "streak": "Seria",
        "best_streak": "Najlepsza seria",
        "solved": "Odpowiedziano",
        "correct": "Zgadza si?",
        "accuracy": "Dok?adno??",
        "bookmarks": "Zak?adki",
        "contribute": "Przyczyn",
        "likes": "Lubi?",
        "language_mastered": "Mastered",
        "language_learning": "Nauka",
        "last_7_days": "Ostatnie 7 dni",
        "days_suffix": "d",
        "no_activity": "Jeszcze brak aktywno?ci",
        "weekly_league": "Cotygodniowa liga",
        "league_tiers": "Poziomy ligowe",
        "league_tiers_hint": "Poziomy od najni?szego do najwy?szego. Uko?cz pierwsz? grup?, aby awansowa?; najni?si relegaci. ",
        "league_position": "#{{position}} {{total}} w tym tygodniu",
        "view_leaderboard": "Pe?na sala",
        "how_leagues_work": "Jak to dzia?a",
        "you": "Ty"
    },
    "gamification": {
        "level": "Poziom",
        "rank": "Stopie?",
        "streak": "Seria",
        "daily_goals": "Codzienne cele",
        "achievements": "Osi?gni?cia",
        "leaderboard": "Tabela wynik?w",
        "season": "Sezon",
        "xp_to_next": "{{current}} / {{next}} XP na kolejny poziom",
        "weekly": "Tygodniowo",
        "monthly": "W tym miesi?cu",
        "overall": "Og?lnie",
        "monthly_hint": "Klasyfikuje graczy wed?ug rankingowych XP zdobytych w bie??cym miesi?cu kalendarzowym (takie same malej?ce zwroty jak w ligach tygodniowych). To nie jest osobny poziom ligowy. ",
        "overall_hint": "Ranking wszech czas?w wed?ug sta?ej ??cznej liczby XP. ",
        "overall_empty": "Na li?cie og?lnej jeszcze nie ma graczy. ",
        "players": "Cz?onkowie",
        "full_board": "Pe?na sala",
        "player": "Cz?onek",
        "ranked_xp": "Rankingowe XP",
        "total_xp": "Ca?kowite XP",
        "standing": "Mandat",
        "zone": "Mandat",
        "zone_promotion": "Promocja",
        "zone_safe": "Safe",
        "zone_relegation": "Spadek",
        "zone_legend": "Na g?rze {{promo}} awansowa? ? Na dole {{releg}} spada? w weekend. ",
        "unlocked": "Odblokowane",
        "achievements_error": "Nie uda?o si? za?adowa? osi?gni??",
        "achievements_intro": "Odblokuj odznaki podczas gry ? aktywno??, celno??, serie, trudno?? i uczenie si? na b??dach. ",
        "achievement_categories": {
            "activity": "Dzia?alno??",
            "correct_answers": "Poprawne odpowiedzi",
            "learning_from_mistakes": "Uczenie si? na b??dach",
            "streaks": "Serie",
            "difficulty": "Trudno??",
            "variety": "R??norodno??",
            "general": "Og?lne"
        },
        "achievement_category_hints": {
            "learning_from_mistakes": "Po b??dnej odpowiedzi quiz mo?e wr?ci? p??niej do przegl?du. Poprawna odpowied? liczy si? tutaj. "
        },
        "your_rank": "Tw?j stopie?",
        "around_you": "Wok?? ciebie",
        "tooltip_total_xp": "{{xp}} ca?kowite do?wiadczenie",
        "tooltip_level": "Poziom {{level}}",
        "weekly_waiting": "Nie mog? za?adowa? twojej cotygodniowej grupy. Prosz? spr?bowa? ponownie. ",
        "weekly_ineligible": "Graj dalej, aby odblokowa? cotygodniowe ligi. ",
        "achievements_progress": "{{unlocked}} / {{total}} odblokowane",
        "toast": {
            "xp_gained": "+{{xp}} XP",
            "achievement": "Odblokowane osi?gni?cia: {{name}}"
        },
        "level_up": {
            "title": "Awansuj! ",
            "body": "Osi?gn??e? poziom {{level}}",
            "continue": "Id? dalej"
        }
    },
    "creator": {
        "rank": "Ranga tw?rcy",
        "xp": "Creator XP",
        "tooltip_rank": "{{rank}}",
        "tooltip_cxp": "{{xp}} CXP",
        "approved": "Zatwierdzone sk?adki",
        "views": "Pogl?dy",
        "completions": "Uko?czenia",
        "likes": "Lubi?",
        "bookmarks": "Zak?adki",
        "top_contribution": "Najwa?niejszy wk?ad",
        "newest_contribution": "Najnowszy wk?ad",
        "to_next": "Do nast?pnego stopnia",
        "players_board": "Cz?onkowie",
        "creators_board": "Wsp??pracownicy",
        "board_group": "Typ planszy",
        "weekly": "Tygodniowo",
        "monthly": "Miesi?cznik",
        "all_time": "Ca?y czas",
        "weekly_hint": "Tw?rcy uszeregowani wed?ug XP Tw?rc?w zdobyci w tym tygodniu. ",
        "monthly_hint": "Tw?rcy uszeregowani wed?ug Creator XP zdobyci w tym miesi?cu. ",
        "all_time_hint": "Wszech czas?w wed?ug Creator XP. ",
        "empty": "Na forum jeszcze nie ma tw?rc?w. "
    },
    "profile": {
        "title": "M?j profil",
        "edit": {
            "title": "Edytuj profil"
        },
        "nav": {
            "label": "Relacja",
            "overview": "Przegl?d",
            "stats": "Statystyki",
            "leagues": "Ligi",
            "edit": "Edytuj profil",
            "contribute": "Przyczyn",
            "bookmarks": "Zak?adki",
            "achievements": "Osi?gni?cia",
            "leaderboards": "Tabele wynik?w",
            "browse": "Przegl?daj tre?ci"
        },
        "actions": {
            "back_to_home": "Powr?t do domu",
            "back_to_profile": "Powr?t do profilu",
            "edit": "Edytuj profil",
            "contribute": "Przyczyn"
        },
        "labels": {
            "initials": "Inicja?y",
            "role": "Rola",
            "status": "Status",
            "sign_in_method": "Metoda logowania",
            "member_since": "Cz?onek od czasu",
            "country": "Kraj",
            "reliable": "Wiarygodny wsp??tw?rca"
        },
        "sections": {
            "account_info": "Informacje o kontach",
            "authentication": "Uwierzytelnianie",
            "creator": "Tw?rca",
            "stats": "Twoje statystyki",
            "leagues": "Ligi tygodniowe"
        },
        "stats": {
            "title": "Statystyki",
            "subtitle": "Przegl?d Twoich post?p?w, aktywno?ci i tygodniowej ligi. ",
            "empty": "Jeszcze ?adnych statystyk. Zr?b kilka quiz?w, ?eby zacz??. ",
            "periods": "Dzi? i w tym tygodniu",
            "today": "Dzi?",
            "see_all": "Wszystkie statystyki",
            "see_leagues": "Strona otwartych lig"
        },
        "leagues": {
            "title": "Ligi",
            "subtitle": "Tw?j tygodniowy poziom ligowy, pozycja grupowa oraz strefa awansowa lub spadkowa. ",
            "your_group": "Twoja grupa w tym tygodniu",
            "see_all": "Ligi otwarte"
        }
    },
    "notifications": {
        "title": "Powiadomienia",
        "hint": "Otrzymuj powiadomienia o swojej serii, pozycji w lidze i tre?ci ? nawet gdy Procrastiq zamkni?ta. ",
        "enable": "W??cz powiadomienia",
        "disable": "Wy??cz na tym urz?dzeniu",
        "enabled": "Powiadomienia w??czone",
        "disabled": "Powiadomienia wy??czone na tym urz?dzeniu",
        "enable_failed": "Nie mo?na by?o w??czy? powiadomie?",
        "disable_failed": "Nie mo?na by?o wy??czy? powiadomie?",
        "prefs_failed": "Nie uda?o si? zapisa? preferencji",
        "unsupported": "Powiadomienia push nie s? obs?ugiwane w tej przegl?darce. ",
        "pref_ranking": "Liga i ranking",
        "pref_streak": "Seria",
        "pref_reactions": "Reakcje na moje tre?ci",
        "pref_approved": "Zatwierdzenie tre?ci"
    },
    "games": {
        "challenge_friend": "Challenge a friend",
        "survival_mode": "Survival",
        "challenges_inbox": "Challenges",
        "view_inbox": "View inbox",
        "pick_friend": "Pick a friend",
        "random_opponent": "Random opponent",
        "search_users": "Search by name?",
        "search_error": "Could not search users",
        "selected": "Selected",
        "selected_opponent": "Selected player",
        "pick_opponent": "Pick an opponent first",
        "random_hint": "We'll match you with an active player.",
        "any_category": "Any category",
        "category_optional": "Category (optional)",
        "start_challenge": "Send challenge",
        "challenge_created": "Challenge sent!",
        "create_error": "Could not create challenge",
        "challenge": "Challenge",
        "open": "Open",
        "new_challenge": "New challenge",
        "start_playing": "Start playing",
        "accept_play": "Accept & play",
        "decline": "Decline",
        "decline_error": "Could not decline challenge",
        "your_result": "Your result",
        "opponent_result": "Opponent",
        "waiting_opponent": "Waiting for your opponent to finish?",
        "score_line": "{{correct}}/{{total}} correct ? {{time}}",
        "you_won": "You won!",
        "you_lost": "You lost",
        "draw": "It's a draw",
        "submitting": "Submitting answers?",
        "submit_error": "Could not submit challenge",
        "load_error": "Could not load",
        "not_found": "Challenge not found",
        "no_challenges": "No challenges yet",
        "incoming": "Incoming",
        "outgoing": "Outgoing",
        "player": "Player",
        "filter": {
            "incoming": "Incoming",
            "outgoing": "Outgoing",
            "all": "All"
        },
        "status": {
            "pending": "Pending",
            "in_progress": "In progress",
            "completed": "Completed",
            "declined": "Declined",
            "expired": "Expired"
        },
        "question_progress": "Question {{current}} / {{total}}",
        "time_left": "{{seconds}}s",
        "elapsed_time": "Time {{time}}",
        "overall_time": "Total time",
        "total_time_left": "Total {{seconds}}s",
        "no_options": "No answer options for this question",
        "survival_leaderboard": "Survival leaderboard",
        "survival_leaderboard_hint": "Best survival run per player in the selected period.",
        "survival_empty": "No survival scores yet ? be the first!",
        "play_survival": "Play Survival",
        "current_score": "Score: {{score}}",
        "game_over": "Game over",
        "final_score": "You scored {{score}}",
        "personal_best": "Personal best: {{score}}",
        "daily_rank": "Daily rank: #{{rank}}",
        "weekly_rank": "Weekly rank: #{{rank}}",
        "play_again": "Play again",
        "survival_start_error": "Could not start survival run",
        "survival_error": "Survival error",
        "daily": "Daily",
        "weekly": "Weekly",
        "all_time": "All time",
        "score": "Score",
        "challenge_user": "Challenge {{name}}",
        "login_to_challenge": "Log in to challenge this player",
        "profile_error": "Could not load profile",
        "profile_not_found": "Player not found",
        "profile": "Profile",
        "notifications": "Notifications",
        "mark_all_read": "Mark all read",
        "no_notifications": "No notifications",
        "blocked_users": "Blocked players",
        "blocked_hint": "Blocked players cannot challenge you.",
        "no_blocked": "You haven't blocked anyone.",
        "unblock": "Unblock",
        "unblocked": "Player unblocked",
        "unblock_error": "Could not unblock player",
        "blocked_load_error": "Could not load blocked players",
        "survival_howto": "Odpowiadaj poprawnie jak najd?u?ej. Masz 20 sekund na pytanie. Jeden b??d jest wybaczany ? drugi ko?czy gr?. Wynik to liczba poprawnych odpowiedzi.",
        "challenge_howto": "Dziesi?? pyta?, 20 sekund na ka?de. Wygrywa wi?cej poprawnych odpowiedzi i kr?tszy czas. Wynik przeciwnika zobaczysz, gdy sko?czycie oboje.",
        "continue": "Kontynuuj",
        "survival_reserve": "Rezerwa: {{count}}",
        "survival_second_chance": "Druga szansa!",
        "guest_teaser": "Log in to challenge friends and climb Survival ranks."
    }
};
